<template>
    <div class="bto-sb-widget bto-sb-widget-collapsed bto-sb-widget-sportlist-menu bto-sb-widget-livesportlist-menu"
      :class="{'bto-sb-widget-collapsed-active' : expanded}">
        <div class="bto-sb-widget-title bto-sb-widget-title-icon" @click="toggleWidgetExpand()">
            <span class="bto-sb-widget-title-icon"></span>
            <h3>{{t('Mobile.LiveNow')}}</h3>
            <span class="bto-sb-widget-title-arrow"></span>
        </div>
        <div ref="lfmenu">
            <div>
                <div class="bto-sb-widget-content" v-show="expanded">
                    <ul>
                        <li v-for="(liveSports, idx) in fixtureData" :key="idx">
              <span class="bto-sb-sportlist-menu-item" @click="toggleActive(idx)">
                <span class="bto-sb-sports-icon" :class="getSportClass(liveSports[0])"></span>
                <span class="bto-sb-sportlist-menu-sport-name">{{getSportName(liveSports[0])}}</span>
                <span class="bto-sb-sportlist-menu-sport-events">{{liveSports[1].length}}</span>
              </span>
                            <ul class="bto-sb-sportlist-menu-level-2" v-show="activeTabs[idx]">
                                <live-fixture-item-component
                                        v-for="(sportMatch, idx) in new Array(liveSports[1].length).fill(null)"
                                        :key="idx"
                                        :index="idx"
                                        :sportMatchesSorted="liveSports[1]"
                                        :matchSelectedId="matchSelectedId"
                                        :liveMatchClick="liveMatchClick"
                                />
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import store from '../../../store/index';
  import { EventBus } from '../../../services/event-bus-service';
  import LiveFixtureItemComponent from './component-live-fixture-item';
  import { LiveWorker } from "../../../workers";

  export default {
    name: 'LiveFixtureMenuWidget',
    data() {
      return {
        fixtureData: [],
        expanded: true,
        activeTabs: {
          0: true,
        },
        matchSelectedId: this.$router.currentRoute.params.matchId || 0,
        unwatch: null,
      };
    },
    components: {
      LiveFixtureItemComponent,
    },
    methods: {
      toggleActive(idx) {
        if (this.activeTabs[idx]) {
          delete this.activeTabs[idx];
        } else {
          this.activeTabs[idx] = true;
        }
        this.activeTabs = Object.assign({}, this.activeTabs);
      },
      getSportName(sportId) {
        return store.getters.getSportName(sportId);
      },
      getSportClass(sportId) {
        return store.getters.getSportClass(sportId);
      },
      toggleWidgetExpand() {
        this.expanded = !this.expanded;
      },
      liveMatchClick(match) {
        EventBus.$emit('liveFixtureMatchClicked', match);
      },
      init() {
        // check if route is empty or has given params
        // this guards if we go in event-view -> upcoming and are in upcoming match after watcher emits event
        if (this.$router.currentRoute.params.matchId && (this.$router.currentRoute.name === 'seoGameLive' || this.$router.currentRoute.params.matchType)) {
          return;
        }
        const firstLiveMatch = this.fixtureData[0][1][0];
        this.liveMatchClick(firstLiveMatch);
      },
      handleEmptyLiveRoute(skipNextTick = false) {
        // if we have live matches date get the first match
        if (this.fixtureData.length > 0) {
          // if skipNextTick is true call init immediately otherwise wait nextTick
          // we need nextTick only when component is created in order for parent to catch the event
          skipNextTick ? this.init() : this.$nextTick(this.init);
        } else {
          // if empty route and no live match data wait for live matches data
          // reset watcher if we have one active
          this.resetWatcher();
          const unwatch = this.$watch('fixtureData', () => {
            if (this.fixtureData.length > 0) {
              this.init();
              // stop watching after we init
              this.resetWatcher();
            }
          });
          this.unwatch = unwatch;
        }
      },
      resetWatcher() {
        if (this.unwatch) {
          this.unwatch();
          this.unwatch = null;
        }
      },
      handleLeftColToggle(expanded) {
        if (expanded) {
          if (typeof this.$refs.lfmenu !== 'undefined') {
            Vue.prototype.$vuebar.destroyScrollbar(this.$refs.lfmenu, { clearStyles: true });
            this.$refs.lfmenu.style.height = 'auto';
            this.$refs.lfmenu.firstElementChild.removeAttribute("style");
          }
        } else {
          this.$nextTick(() => {
            setTimeout(() => {
              if (typeof this.$refs.lfmenu !== 'undefined') {
                this.$refs.lfmenu.style.height = `${400}px`;
                Vue.prototype.$vuebar.initScrollbar(this.$refs.lfmenu, {});
              }
            }, 0);
          });
        }
      },
      handleLiveData(msg) {
        if (msg.data.type === 'liveall') {
          let activeIdx = 0;
          this.fixtureData = Object.entries(msg.data.data.lm).sort(
            (a, b) => (b[1][Object.keys(b[1])[0]].sportOrder < a[1][Object.keys(a[1])[0]].sportOrder) ? 1 : -1)
            .reduce((acc, cv) => {
              const sortedMatches = Object.values(cv[1]).sort((a, b) => {
                // Store index of selected sport tab
                if (this.matchSelectedId == a.betRadarId || this.matchSelectedId == b.betRadarId) {
                  activeIdx = acc.length;
                }
                if (a.tournamentOrder === b.tournamentOrder) {
                  return a.matchOrder - b.matchOrder;
                }
                return a.tournamentOrder - b.tournamentOrder;
              });
              acc.push([cv[0], sortedMatches]);
              return acc;
            }, []);
          // Set active tab to currently selected sport
          if (activeIdx && !this.activeTabs[activeIdx]) {
            this.toggleActive(0);
            this.toggleActive(activeIdx);
          }
        }
      },
    },
    created() {
      LiveWorker.postMessage({ ev: 'liveall', resp: {} });
      LiveWorker.addEventListener('message', this.handleLiveData);
      if (this.$router.currentRoute.params.matchId && this.$router.currentRoute.name === 'seoGameLive') { 
        return;
      }
      this.handleEmptyLiveRoute();
    },
    mounted() {
      EventBus.$on('leftColToggle', this.handleLeftColToggle);
    },
    beforeDestroy() {
      EventBus.$off('leftColToggle', this.handleLeftColToggle);
      LiveWorker.removeEventListener('message', this.handleLiveData);
      this.resetWatcher();
    },
    watch: {
      '$route': function (to) {
        if (this.$route.name === 'seoGameLive') {
          this.matchSelectedId = to.params.matchId;
        } else {
          this.matchSelectedId = null;
        }
        if (!to.params.matchId) {
          this.handleEmptyLiveRoute(true);
        }
      }
    },
  };
</script>
